// Quick-start bar presets: each maps a label to the prompt inserted into the editor.
export function getQuickStartActions ($t) {
    return [
        {
            id: 'featureUsage',
            label: $t('askPendo.quickStart.Feature_usage'),
            prompt: $t('askPendo.quickStart.prompts.Feature_usage'),
            placeholderTypes: ['feature'],
        },
        {
            id: 'releaseAdoption',
            label: $t('askPendo.quickStart.Release_adoption'),
            prompt: $t('askPendo.quickStart.prompts.Release_adoption'),
            placeholderTypes: ['feature', 'date'],
        },
        {
            id: 'accountNps',
            label: $t('askPendo.quickStart.Account_NPS'),
            prompt: $t('askPendo.quickStart.prompts.Account_NPS'),
            placeholderTypes: ['account'],
        },
        {
            id: 'funnelDropOff',
            label: $t('askPendo.quickStart.Funnel_drop_off'),
            prompt: $t('askPendo.quickStart.prompts.Funnel_drop_off'),
            placeholderTypes: ['page', 'feature'],
        },
    ];
}

/**
 * Starter prompts for a drawer conversation opened on a page Leo has no context for.
 * Reuses the how-to presets because their prompts are ready to send as-is, unlike the
 * quick-start actions whose prompts contain placeholders the user must fill in.
 */
export function getDefaultDrawerPrompts ($t) {
    const ids = ['getStarted', 'buildDashboard', 'captureFeedback'];

    return getHowToOptions($t).filter((option) => ids.includes(option.id));
}

export function getHowToOptions ($t) {
    return [
        {
            id: 'getStarted',
            label: $t('askPendo.quickStart.How_to_get_started_with_Pendo'),
            prompt: $t('askPendo.quickStart.prompts.How_to_get_started_with_Pendo'),
        },
        {
            id: 'buildDashboard',
            label: $t('askPendo.quickStart.How_to_build_a_dashboard_using_templates'),
            prompt: $t('askPendo.quickStart.prompts.How_to_build_a_dashboard_using_templates'),
        },
        {
            id: 'captureFeedback',
            label: $t('askPendo.quickStart.How_to_capture_feedback'),
            prompt: $t('askPendo.quickStart.prompts.How_to_capture_feedback'),
        },
        {
            id: 'validateIdeas',
            label: $t('askPendo.quickStart.How_to_validate_product_ideas'),
            prompt: $t('askPendo.quickStart.prompts.How_to_validate_product_ideas'),
        },
        {
            id: 'launchGuidance',
            label: $t('askPendo.quickStart.How_to_launch_in_app_product_guidance'),
            prompt: $t('askPendo.quickStart.prompts.How_to_launch_in_app_product_guidance'),
        },
    ];
}
